/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeRewardNotificationActionData } from './ChallengeRewardNotificationActionData';
import {
    ChallengeRewardNotificationActionDataFromJSON,
    ChallengeRewardNotificationActionDataFromJSONTyped,
    ChallengeRewardNotificationActionDataToJSON,
} from './ChallengeRewardNotificationActionData';

/**
 * 
 * @export
 * @interface ChallengeRewardNotificationAction
 */
export interface ChallengeRewardNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeRewardNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {ChallengeRewardNotificationActionData}
     * @memberof ChallengeRewardNotificationAction
     */
    data: ChallengeRewardNotificationActionData;
}

/**
 * Check if a given object implements the ChallengeRewardNotificationAction interface.
 */
export function instanceOfChallengeRewardNotificationAction(value: object): value is ChallengeRewardNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ChallengeRewardNotificationActionFromJSON(json: any): ChallengeRewardNotificationAction {
    return ChallengeRewardNotificationActionFromJSONTyped(json, false);
}

export function ChallengeRewardNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRewardNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': ChallengeRewardNotificationActionDataFromJSON(json['data']),
    };
}

export function ChallengeRewardNotificationActionToJSON(value?: ChallengeRewardNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': ChallengeRewardNotificationActionDataToJSON(value.data),
    };
}

